module.exports = __webpack_public_path__ + "static/media/sn_tiktok.cea8383d.svg";